import * as Sentry from '@sentry/react';
import { isRunningAsPwa } from '@utils/pwa';

export type AuthStep =
  | 'analytics'
  | 'finalize'
  | 'loadUser'
  | 'loadAdmin'
  | 'missingSessionId'
  | 'missingSessionIdRecovered'
  | 'redeem';

const describeError = (error: unknown) => {
  if (!error || typeof error !== 'object') return { message: String(error) };
  const { name, message, status, url } = error as Partial<Error & { status: number; url: string }>;
  return { name, message, status, url };
};

export const reportAuthError = (
  step: AuthStep,
  error: unknown,
  level: Sentry.SeverityLevel = 'error',
) => {
  Sentry.captureException(error instanceof Error ? error : new Error(`Auth step failed: ${step}`), {
    level,
    tags: { area: 'auth', authStep: step, pwa: isRunningAsPwa() },
    extra: { ...describeError(error), host: window.location.host },
  });
};
